<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDisciplineFilesConfirm } from '../../model/modal-discipline-files-confirm.hook'

defineOptions({
  name: 'ModalDisciplineFilePackDelete',
})

const {
  refIsDeleteOpen,
  refIsLoading,
  closeModal,
  deletePack,
} = useModalDisciplineFilesConfirm()
</script>

<template>
  <ModalConfirmation
    :show="refIsDeleteOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete sent file from parent cabinet?"
    button-title="Delete files"
    @click:confirm="deletePack"
    @click:cancel="closeModal"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        Are you sure you want to delete this file? This action cannot be undone.
      </AppText>
    </template>
  </ModalConfirmation>
</template>
